"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countDecimals = exports.roundToDec = exports.formatStringToNumber = exports.formatInputNumberToString = exports.formatInputAsString = void 0;
exports.formatInputAsString = (number, numDec) => {
    number = number || 0;
    if (exports.countDecimals(number) <= numDec) {
        return number.toString();
    }
    else {
        return exports.roundToDec(number, numDec).toString();
    }
};
exports.formatInputNumberToString = (number, numDec) => {
    const convertedNumber = Number(number) || 0;
    if (exports.countDecimals(convertedNumber) <= numDec) {
        return convertedNumber.toString();
    }
    else {
        return exports.roundToDec(convertedNumber, numDec).toString();
    }
};
exports.formatStringToNumber = (number, numDec) => {
    const convertedNumber = Number(number) || 0;
    if (exports.countDecimals(convertedNumber) <= numDec) {
        return convertedNumber;
    }
    else {
        return exports.roundToDec(convertedNumber, numDec);
    }
};
exports.roundToDec = (number, numDec) => {
    let multiplier = Math.pow(10, numDec);
    let biggerNum = number * multiplier;
    let roundedBigNum = Math.round(biggerNum);
    return roundedBigNum / multiplier;
};
exports.countDecimals = (value) => {
    if (Math.floor(value) !== value)
        return value.toString().split(".")[1].length || 0;
    return 0;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybWF0dGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Z1bmN0aW9ucy9mb3JtYXR0ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxtQkFBbUIsR0FBRyxDQUFDLE1BQWMsRUFBRSxNQUFjLEVBQVUsRUFBRTtJQUMxRSxNQUFNLEdBQUcsTUFBTSxJQUFJLENBQUMsQ0FBQztJQUVyQixJQUFJLHFCQUFhLENBQUMsTUFBTSxDQUFDLElBQUksTUFBTSxFQUFFO1FBQ2pDLE9BQU8sTUFBTSxDQUFDLFFBQVEsRUFBRSxDQUFDO0tBQzVCO1NBQU07UUFDSCxPQUFPLGtCQUFVLENBQUMsTUFBTSxFQUFFLE1BQU0sQ0FBQyxDQUFDLFFBQVEsRUFBRSxDQUFDO0tBQ2hEO0FBQ0wsQ0FBQyxDQUFDO0FBRVcsUUFBQSx5QkFBeUIsR0FBRyxDQUFDLE1BQWMsRUFBRSxNQUFjLEVBQVUsRUFBRTtJQUNoRixNQUFNLGVBQWUsR0FBRyxNQUFNLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBRTVDLElBQUkscUJBQWEsQ0FBQyxlQUFlLENBQUMsSUFBSSxNQUFNLEVBQUU7UUFDMUMsT0FBTyxlQUFlLENBQUMsUUFBUSxFQUFFLENBQUM7S0FDckM7U0FBTTtRQUNILE9BQU8sa0JBQVUsQ0FBQyxlQUFlLEVBQUUsTUFBTSxDQUFDLENBQUMsUUFBUSxFQUFFLENBQUM7S0FDekQ7QUFDTCxDQUFDLENBQUM7QUFFVyxRQUFBLG9CQUFvQixHQUFHLENBQUMsTUFBYyxFQUFFLE1BQWMsRUFBVSxFQUFFO0lBQzNFLE1BQU0sZUFBZSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLENBQUM7SUFFNUMsSUFBSSxxQkFBYSxDQUFDLGVBQWUsQ0FBQyxJQUFJLE1BQU0sRUFBRTtRQUMxQyxPQUFPLGVBQWUsQ0FBQztLQUMxQjtTQUFNO1FBQ0gsT0FBTyxrQkFBVSxDQUFDLGVBQWUsRUFBRSxNQUFNLENBQUMsQ0FBQztLQUM5QztBQUNMLENBQUMsQ0FBQztBQUVXLFFBQUEsVUFBVSxHQUFHLENBQUMsTUFBYyxFQUFFLE1BQWMsRUFBRSxFQUFFO0lBQ3pELElBQUksVUFBVSxHQUFHLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxFQUFFLE1BQU0sQ0FBQyxDQUFDO0lBQ3RDLElBQUksU0FBUyxHQUFHLE1BQU0sR0FBRyxVQUFVLENBQUM7SUFDcEMsSUFBSSxhQUFhLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsQ0FBQztJQUMxQyxPQUFPLGFBQWEsR0FBRyxVQUFVLENBQUM7QUFDdEMsQ0FBQyxDQUFDO0FBRVcsUUFBQSxhQUFhLEdBQUcsQ0FBQyxLQUFhLEVBQUUsRUFBRTtJQUMzQyxJQUFJLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLEtBQUssS0FBSztRQUMzQixPQUFPLEtBQUssQ0FBQyxRQUFRLEVBQUUsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsTUFBTSxJQUFJLENBQUMsQ0FBQztJQUN0RCxPQUFPLENBQUMsQ0FBQztBQUNiLENBQUMsQ0FBQyJ9